import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'shared/components/ui/button'

const NoFound = () => {
  const navigate = useNavigate()
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-bg px-6 text-center text-ink">
      <p className="mb-2 text-6xl font-extrabold text-theme">404</p>
      <p className="mb-6 text-muted">That screen is not part of Gate Scanner.</p>
      <Button onClick={() => navigate('/')}>Back to events</Button>
    </div>
  )
}

export default NoFound
